<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">門市列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6 text-left">
                  <div class="form-group text-left" v-if="!history && (getRoleType === 99 ||  getRoleType === 30)">
                    <router-link :to="{path: '/crStore/' + $route.params.brand_id}" v-if="getRoleType === 99">
                      <div class="btn btn-default btn-table-title">新增門市</div>
                    </router-link>
                    <router-link :to="{path: '/batchSetupStore/' + $route.params.brand_id}" v-if="getRoleType !== 50 && getRoleType !== 10">
                      <div class="btn btn-default btn-table-title">批次設定門市資訊</div>
                    </router-link>
                  </div>
                  <br>
                  <div class="form-group">
                    <select class="form-control h-38" v-model="statusSelect">
                      <option v-for="(type, index) in statusTypeList" :value="type.value" :key="`option-${index}`">
                        {{type.label}}
                      </option>
                    </select>
                  </div>
                  <div class="form-group text-left">
                    <select class="form-control h-38" v-model="orderStatusSelect">
                      <option value="99">== 接單狀態 ==</option>
                      <option value="10">接單中</option>
                      <option value="20">不接單</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control h-38" v-model="isSearchSelect">
                      <option value="99">== 搜尋狀態 ==</option>
                      <option value="1">可搜尋</option>
                      <option value="0">不可搜尋</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control h-38" v-model="trTypeSelect">
                      <option v-for="trade in getTradeType" :value="trade.value">
                        {{trade.label}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="form-group">
                    <select class="form-control h-38" v-model="searchSelect">
                      <option value="1">名稱</option>
                      <!--<option value="2">代碼</option>-->
                    </select>
                  </div>
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="searchInput">
                      <span class="input-group-addon c-pointer" @click="searchStore()"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                  <br>
                  <div class="btn btn-default btn-table-title"
                    :disabled="isDownloading"
                    @click="exportFile()">
                    <i class="fa fa-download"></i>
                    匯出門市清單
                    <Clip class="cliploading" :loading="isDownloading" :color="'#528BB8'" :size="'16px'"/>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                      <tr role="row">
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">門市</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat">名稱 (ID)</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">縮寫</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat" v-if="!history">地址</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="!history">電話</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">營業</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">接單</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">前台</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="!history">搜尋</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit" v-if="!history">付款</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat" v-if="!history && getRoleType === 99">計費方式</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fit" v-if="!history">廣告</th>
                        <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="getRoleType !== 50"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="even" role="row" v-for="(store, index) in storeList">
                        <!-- column 0 -->
                        <td class="sorting_1">
                          {{index + 1}}
                        </td>
                        <!-- column 1 -->
                        <td>
                          <a target="_blank" :href="webDomain + 'menu/' + store.id">
                            <img class="img-brand-table" :src="store.image">
                          </a>
                        </td>
                        <!-- column 2 -->
                        <td>
                          <span v-if="$route.name == 'storeHistoryTable'">{{store.name}} ({{store.id}})</span>
                          <router-link v-if="$route.name != 'storeHistoryTable'" :to="{path: '/storeInfo/' + $route.params.brand_id + '/' + store.id}">{{store.name}} ({{store.id}})</router-link>
                        </td>
                        <!-- column 3 -->
                        <td>{{store.name_short}}</td>
                        <!-- column 4 -->
                        <td v-if="!history">
                          <small>
                            <span v-for="deliveryTeyp in getPickupType" v-if="getDTypeInfo(store.delivery_info, deliveryTeyp) && getDTypeInfo(store.delivery_info, deliveryTeyp).is_support">
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 1" class="fa fa-hand-paper-o" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 2" class="fa fa-inbox" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 3" class="fa fa-motorcycle" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 4" class="fa fa-shopping-bag" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 5" class="fa fa-glass" aria-hidden="true"></i>
                              <i v-if="getDTypeInfo(store.delivery_info, deliveryTeyp).delivery_type === 21" class="fa fa-qrcode" aria-hidden="true"></i>
                              &nbsp;
                            </span>
                            {{store.address}}
                          </small>
                        </td>
                        <td v-if="!history">{{store.tel}} <br> {{store.tel2}}</td>
                        <td>
                          <span v-if="store.status == 2" class="label label-success">{{getStateName(store.status)}}</span>
                          <span v-if="store.status != 2"  class="label label-danger">{{getStateName(store.status)}}</span>
                        </td>
                        <td>
                          <span v-if="store.order_status  == 10" class="label label-success">接單中</span>
                          <span v-if="store.order_status  == 20"  class="label label-danger">不接單</span>
                        </td>
                        <td>
                          <span v-if="store.is_visible" class="label label-success">顯示</span>
                          <span v-if="!store.is_visible"  class="label label-danger">隱藏</span>
                        </td>
                        <td>
                          <span v-if="store.is_search" class="label label-success">可搜</span>
                          <span v-if="!store.is_search"  class="label label-danger">不可搜</span>
                        </td>
                        <td>
                          <span v-for="trade in store.trade_info" v-if="trade.is_enable">
                            <label class="label" :class="stateColor(trade.name)">{{tradeType(trade.name)}}</label><br>
                          </span>
                        </td>
                        <!-- 計費方式 -->
                        <td v-if="!history && getRoleType === 99">
                          <span v-if="store.order_commission_setting && store.order_commission_setting.type === 3">資訊服務費抽成</span>
                          <span v-else-if="store.order_commission_setting && store.order_commission_setting.type === 2">系統費+資訊服務費抽成</span>
                          <span v-else>系統費</span>
                        </td>
                        <!-- End 計費方式 -->
                        <td v-if="!history">
                          <router-link :to="{path: '/adTable/' + $route.params.brand_id + '/' + store.id}">
                            <button class="btn btn-default"><i class="fa fa-file-image-o" aria-hidden="true"></i></button>
                          </router-link>
                        </td>
                        <!-- column last-->
                        <td v-if="!history && getRoleType !== 50">
                          <router-link :to="{path: '/upStore/' + $route.params.brand_id + '/' + store.id}">
                            <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                          </router-link>
                        </td>
                        <td v-if="history">
                          <router-link :to="{path: '/oneStoreHistoryTable/' + $route.params.brand_id +'/' + store.id}">
                            <button class="btn btn-default"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <paginate
                  :pageAmount="pageAmount"
                  :total="total"
                  :isActive="isActive"
                  :groupAmount="groupAmount"
                  :clickPage="clickPage"
                  ref="brandPaginate"
                >
                </paginate>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="openModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{current.name}}營業時間</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">星期</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">營業時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">訂購時間</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(open, index) in current.openList">
                    <td>星期{{getDayName(open.week_day)}}</td>
                    <td>{{open.start_time}} ～ {{open.end_time}}</td>
                    <td>{{open.order_start_time}} ～ {{open.order_end_time}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="deliveryModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{current.name}}外送門檻</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">外送類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">店家交付ID</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">最低消費門檻</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">距離門檻</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(delivery, index) in current.deliveryList">
                    <td>{{ delivery.delivery_type | deliveryName}}</td>
                    <td>
                      <span v-if="delivery.is_support" class="label label-success">使用</span>
                      <span v-if="!delivery.is_support"  class="label label-danger">不使用</span>
                    </td>
                    <td>{{delivery.id}}</td>
                    <td>{{delivery.order_min_price}}</td>
                    <td>{{delivery.order_min_distance_m}}
                      <span v-if="delivery.delivery_type !== 3">(最低)</span>
                      <span v-if="delivery.delivery_type === 3">(最高)</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="payModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{current.name}}付款方式</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">付款類型 (ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">店家付款ID</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(pay, index) in current.payList">
                    <td>
                      {{pay.name}} ({{pay.trade_type_id}})
                    </td>
                    <td>
                      <span v-if="pay.is_enable" class="label label-success">使用</span>
                      <span v-if="!pay.is_enable"  class="label label-danger">不使用</span>
                    </td>
                    <td>{{pay.id}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="mqttModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{current.name}}今日連線紀錄</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線狀態</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(mqtt, index) in current.mqttInfo">
                    <td>
                      {{getTime(mqtt.create_time)}}
                    </td>
                    <td>
                      <span v-if="mqtt.status === 1" class="label label-success">連線</span>
                      <span v-if="mqtt.status === 2"  class="label label-danger">中斷</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Clip from 'vue-spinner/src/ClipLoader.vue'
export default {
  name: 'Tables',
  components: {
    Clip
  },
  data () {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      history: false,
      storeList: [],
      current: {
        openList: {},
        deliveryList: {},
        payList: {},
        name: '',
        mqttInfo: []
      },
      searchSelect: 1,
      searchInput: '',
      statusSelect: 99,
      trTypeSelect: 999,
      statusTypeList: [
        {label: '== 營業狀態 ==', value: 99},
        {label: '營業中', value: 2},
        {label: '籌備中', value: 1},
        {label: '尚未營業', value: 0},
        {label: '休息中', value: 3},
        {label: '已歇業', value: 9}
      ],
      orderStatusSelect: 99,
      isSearchSelect: 99,
      isDownloading: false,
      searchQuery: {} // 搜尋條件
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    getDTypeInfo (dInfo, dIndex) {
      return dInfo.find(function (obj) { return obj.delivery_type === dIndex })
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    },
    stateColor (name) {
      if (name.indexOf('現金') > -1) {
        return 'label-default'
      } else if (name.indexOf('LINE') > -1) {
        return 'label-success'
      } else if (name.indexOf('iP') > -1) {
        return 'label-success'
      } else if (name.indexOf('台新') > -1) {
        return 'label-primary'
      } else if (name.indexOf('國泰') > -1) {
        return 'label-primary'
      } else if (name.indexOf('TAPPAY') > -1) {
        return 'label-primary'
      } else if (name.indexOf('街口') > -1) {
        return 'label-danger'
      } else if (name.indexOf('Pi') > -1) {
        return 'label-info'
      } else if (name.indexOf('全盈') > -1) {
        return 'label-primary'
      } else if (name.indexOf('台灣') > -1) {
        return 'label-warning'
      } else if (name.indexOf('icash') > -1) {
        return 'label-info'
      } else if (name.indexOf('全支付') > -1) {
        return 'label-warning'
      } else if (name.indexOf('遠傳電信') > -1) {
        return 'label-danger'
      } else if (name.indexOf('悠遊付') > -1) {
        return 'label-primary'
      } else {
        return 'label-default'
      }
    },
    tradeType (name) {
      if (name.indexOf('現金') > -1) {
        return '現金'
      } else if (name.indexOf('LINE') > -1) {
        return 'LINE PAY'
      } else if (name.indexOf('台新') > -1) {
        return '信用卡(台新)'
      } else if (name.indexOf('國泰') > -1) {
        return '信用卡'
      } else if (name.indexOf('TAPPAY') > -1) {
        return '信用卡'
      } else if (name.indexOf('街口') > -1) {
        return '街口支付'
      } else if (name.indexOf('Pi') > -1) {
        return 'Pi 拍錢包'
      } else if (name.indexOf('全盈') > -1) {
        return '全盈+PAY'
      } else if (name.indexOf('台灣') > -1) {
        return '台灣Pay'
      } else if (name.indexOf('icash') > -1) {
        return 'icash Pay'
      } else if (name.indexOf('全支付') > -1) {
        return '全支付'
      } else if (name.indexOf('遠傳電信') > -1) {
        return '遠傳電信代收'
      } else if (name.indexOf('悠遊付') > -1) {
        return '悠遊付'
      } else {
        return name
      }
    },
    getStateName (state) {
      if (state === 0) {
        return '尚未營業'
      } else if (state === 1) {
        return '籌備中'
      } else if (state === 2) {
        return '營業中'
      } else if (state === 3) {
        return '休息中'
      } else if (state === 9) {
        return '已歇業'
      }
    },
    getDayName (day) {
      if (day === 1) {
        return '日'
      } else if (day === 2) {
        return '一'
      } else if (day === 3) {
        return '二'
      } else if (day === 4) {
        return '三'
      } else if (day === 5) {
        return '四'
      } else if (day === 6) {
        return '五'
      } else if (day === 7) {
        return '六'
      }
    },
    getStoreList () {
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count,
        searchSelect: parseInt(this.searchSelect, 10),
        inputVal: this.searchInput.trim()
      }
      // var url = '/brand/' + this.$route.params.brand_id + '/storeList?page=' + data.page + '&size=' + data.size
      // if (data.searchSelect === 1 && data.inputVal) url = url + '&name=' + data.inputVal
      var url = '/brand/' + this.$route.params.brand_id + '/storeList?size=' + data.size
      let queryValue = {}
      if (data.searchSelect === 1 && data.inputVal) {
        if (this.$route.query.name && this.$route.query.name !== data.inputVal) this.tableIndex = 1
        queryValue = {...queryValue, ...{name: data.inputVal}}
        url = url + '&name=' + data.inputVal
      }
      // 新增篩選
      // if (parseInt(this.statusSelect, 10) !== 99) url = url + '&status=' + this.statusSelect
      // if (parseInt(this.orderStatusSelect, 10) !== 99) url = url + '&order_status=' + this.orderStatusSelect
      // if (parseInt(this.isSearchSelect, 10) !== 99) url = url + '&is_search=' + this.isSearchSelect
      if (parseInt(this.statusSelect, 10) !== 99) {
        if (this.$route.query.status && this.$route.query.status !== this.statusSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{status: this.statusSelect}}
        url = url + '&status=' + this.statusSelect
      }
      if (parseInt(this.orderStatusSelect, 10) !== 99) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{order_status: this.orderStatusSelect}}
        url = url + '&order_status=' + this.orderStatusSelect
      }
      if (parseInt(this.trTypeSelect, 10) !== 999) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{trade_type: this.trTypeSelect}}
        url = url + '&trade_type=' + this.trTypeSelect
      }
      if (parseInt(this.isSearchSelect, 10) !== 99) {
        if (this.$route.query.is_search && this.$route.query.is_search !== this.isSearchSelect) this.tableIndex = 1
        queryValue = {...queryValue, ...{is_search: this.isSearchSelect}}
        url = url + '&is_search=' + this.isSearchSelect
      }
      if (this.tableIndex) {
        queryValue = {...queryValue, ...{page: this.tableIndex}}
        url = url + '&page=' + this.tableIndex
      }
      this.searchQuery = queryValue
      this.$router.push({query: queryValue})
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeList = response.data.list
          self.total = response.data.list_total
          self.$store.commit('SET_BRAND_ID', Number(self.$route.params.brand_id))
          self.$store.commit('SET_STORES', response.data.list)
        }
      })
    },
    openModal (store) {
      this.current.openList = store.opening_info
      this.current.deliveryList = store.delivery_info
      this.current.payList = store.trade_info
      this.current.name = store.name_short
      this.current.mqttInfo = store.mqtt_info
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getStoreList()
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
    },
    searchStore () {
      this.tableIndex = 1
      this.getStoreList()
    },
    // 下載報表
    exportFile () {
      this.isDownloading = true
      let query = this.searchQuery
      let searchParams = ''
      if (query.page) {
        delete query.page
      }
      if (query.size) {
        delete query.size
      }
      if (Object.keys(query).length) {
        searchParams = new URLSearchParams(query)
      }
      const url = '/brand/' + this.$route.params.brand_id + '/storeListSheet?' + searchParams.toString()
      this.getFile('get', url, null, (response) => {
        this.isDownloading = false
        let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = objectUrl
        a.download = `門市清單.xlsx`
        document.body.appendChild(a)
        a.click()
      })
    }
  },
  created () {
    const path = this.$route.name
    if (path === 'storeHistoryTable') this.history = true
    if (this.$route.query.page) this.tableIndex = this.$route.query.page
    if (this.$route.query.name) this.searchInput = this.$route.query.name
    if (this.$route.query.status) this.statusSelect = this.$route.query.status
    if (this.$route.query.order_status) this.orderStatusSelect = this.$route.query.order_status
    if (this.$route.query.is_search) this.isSearchSelect = this.$route.query.is_search
    if (this.$route.query.trade_type) this.trTypeSelect = this.$route.query.trade_type
    this.getStoreList()
  },
  computed: {
    ...mapGetters(['getRoleType', 'getPickupType', 'getTradeType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    webDomain () {
      return this.$config.web
    },
    getFile () {
      return this.$parent.getFile
    }
  },
  watch: {
    statusSelect () {
      this.searchStore()
    },
    orderStatusSelect () {
      this.searchStore()
    },
    isSearchSelect () {
      this.searchStore()
    },
    trTypeSelect () {
      this.searchStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// StoreTable.vue?befed662